import CURPError from './CURPError';
class SuggestedCURPError extends CURPError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SuggestedCURPError', ...args);
    }
}
export default SuggestedCURPError;
